import { Skeleton } from "@mui/material";
import { PageHeaderSkeleton } from "./PageHeaderSkeleton";

export const RoadmapSkeleton = () => {
  return (
    <div className="flex flex-col gap-y-3">
      <PageHeaderSkeleton />
      <div className="py-2 px-3">
        <Skeleton key="Bar" variant="rounded" height={32} width={"100%"} />
        <div className="mt-3 flex gap-x-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i.toString()}
              className="flex flex-1 gap-y-2 flex-col w-1/5 h-full"
            >
              {Array.from({ length: 4 }).map((_, i2) => (
                <Skeleton
                  key={i + "_" + i2}
                  variant="rounded"
                  height={112}
                  width={"100%"}
                  className="flex mr-[6px] rounded-sm p-3 gap-x-2 "
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
